<template>
  <NuxtImg
    v-if="resolvedSrc"
    :src="resolvedSrc"
    :alt="alt"
    preset="logo"
    :width="renderWidth"
    :height="height"
    :sizes="`${displayWidth}px`"
    fit="inside"
    :loading="loading"
    :fetchpriority="fetchpriority"
    :class="imageClass"
    :style="{ height: `${height}px`, width: 'auto', maxWidth: '100%' }"
    decoding="async"
  />
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  src: string
  alt: string
  height: number
  loading?: 'lazy' | 'eager'
  fetchpriority?: 'high' | 'low' | 'auto'
  imageClass?: string
}>(), {
  loading: 'lazy',
  fetchpriority: 'auto',
  imageClass: 'w-auto max-w-full object-contain',
})

const { mediaUrl } = useMediaUrl()

const resolvedSrc = computed(() => {
  if (!props.src?.trim()) return ''
  return mediaUrl(props.src)
})
const displayWidth = computed(() => Math.max(64, Math.ceil(props.height * 2.2)))
const renderWidth = computed(() => Math.min(240, displayWidth.value))
</script>
